/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiKeyEntity } from '../models/ApiKeyEntity';
import type { ApiKeyIdResponse } from '../models/ApiKeyIdResponse';
import type { ApiKeyResponse } from '../models/ApiKeyResponse';
import type { CreateApiKeyDto } from '../models/CreateApiKeyDto';
import type { GetManyApiKeyEntityResponseDto } from '../models/GetManyApiKeyEntityResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ApiKeysApi {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Updates the API-key secret and returns it (for use if the secret was lost)
   * @returns ApiKeyResponse
   * @throws ApiError
   */
  public getNewKey({
    id,
    userId,
  }: {
    /**
     * API-key ID
     */
    id: number,
    userId?: number,
  }): CancelablePromise<ApiKeyResponse> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api-keys/{id}/new-key',
      path: {
        'id': id,
      },
      query: {
        'userId': userId,
      },
    });
  }
  /**
   * Creates an API-key with provided rights
   * @returns ApiKeyResponse
   * @throws ApiError
   */
  public createApiKey({
    requestBody,
    userId,
  }: {
    requestBody: CreateApiKeyDto,
    userId?: number,
  }): CancelablePromise<ApiKeyResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api-keys',
      query: {
        'userId': userId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Retrieve multiple API-keys
   * @returns any Get many base response
   * @throws ApiError
   */
  public getManyApiKeys({
    fields,
    s,
    filter,
    or,
    sort,
    join,
    limit,
    offset,
    page,
    cache,
  }: {
    /**
     * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
     */
    fields?: Array<string>,
    /**
     * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
     */
    s?: string,
    /**
     * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
     */
    filter?: Array<string>,
    /**
     * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
     */
    or?: Array<string>,
    /**
     * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
     */
    sort?: Array<string>,
    /**
     * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
     */
    join?: Array<string>,
    /**
     * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
     */
    limit?: number,
    /**
     * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
     */
    offset?: number,
    /**
     * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
     */
    page?: number,
    /**
     * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
     */
    cache?: number,
  }): CancelablePromise<(GetManyApiKeyEntityResponseDto | Array<ApiKeyEntity>)> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api-keys',
      query: {
        'fields': fields,
        's': s,
        'filter': filter,
        'or': or,
        'sort': sort,
        'join': join,
        'limit': limit,
        'offset': offset,
        'page': page,
        'cache': cache,
      },
    });
  }
  /**
   * Removes API-key
   * @returns ApiKeyIdResponse
   * @throws ApiError
   */
  public deleteApiKey({
    id,
  }: {
    id: number,
  }): CancelablePromise<ApiKeyIdResponse> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api-keys/{id}',
      path: {
        'id': id,
      },
    });
  }
  /**
   * Retrieve a API-key
   * @returns ApiKeyEntity Get one base response
   * @throws ApiError
   */
  public getOneApiKey({
    id,
    fields,
    join,
    cache,
  }: {
    id: number,
    /**
     * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
     */
    fields?: Array<string>,
    /**
     * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
     */
    join?: Array<string>,
    /**
     * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
     */
    cache?: number,
  }): CancelablePromise<ApiKeyEntity> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api-keys/{id}',
      path: {
        'id': id,
      },
      query: {
        'fields': fields,
        'join': join,
        'cache': cache,
      },
    });
  }
}
